import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";
import { ErrorState, LoadingState, EmptyState } from "@/components/States";
import { stagesApi } from "@/lib/api";
import { displayName, formatDateTime } from "@/lib/format";

export default function StagesList() {
  const { t } = useTranslation();
  const q = useQuery({
    queryKey: ["stages", "all"],
    queryFn: () => stagesApi.list({ page_size: 100 }),
  });

  return (
    <>
      <PageHeader
        eyebrow={t("stages.eyebrow")}
        title={t("stages.title")}
        description={t("stages.description")}
      />
      {q.isLoading ? (
        <LoadingState />
      ) : q.isError ? (
        <ErrorState error={q.error} />
      ) : q.data!.items.length === 0 ? (
        <EmptyState title={t("stages.emptyTitle")} hint={t("stages.emptyHint")} />
      ) : (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-surface-alt">
              <tr className="text-left text-text-muted font-mono text-xs uppercase">
                <th className="px-4 py-3">{t("stages.colId")}</th>
                <th className="px-4 py-3">{t("stages.colCode")}</th>
                <th className="px-4 py-3">{t("stages.colName")}</th>
                <th className="px-4 py-3">{t("stages.colStatus")}</th>
                <th className="px-4 py-3">{t("stages.colUpdated")}</th>
              </tr>
            </thead>
            <tbody>
              {q.data!.items.map((s) => (
                <tr key={s.id} className="border-t border-border hover:bg-surface-hover">
                  <td className="px-4 py-3 font-mono text-text-muted tabular-nums">{s.id}</td>
                  <td className="px-4 py-3">
                    <Link to={`/stages/${s.id}`} className="font-mono text-accent-strong hover:underline">
                      {s.code}
                    </Link>
                  </td>
                  <td className="px-4 py-3 text-text-secondary">{displayName(s)}</td>
                  <td className="px-4 py-3">
                    <span className={`pill ${s.is_active ? "pill-ok" : ""}`}>
                      {s.is_active ? t("common.active") : t("common.inactive")}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-text-muted font-mono text-xs">
                    {formatDateTime(s.updated_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
